import { render } from "./sponsors.vue?vue&type=template&id=c91b0c5a&scoped=true"
import script from "./sponsors.vue?vue&type=script&lang=js"
export * from "./sponsors.vue?vue&type=script&lang=js"

import "./sponsors.vue?vue&type=style&index=0&id=c91b0c5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c91b0c5a"

export default script